// src/pages/StatusMessages.tsx
import React, { useReducer } from "react";

interface StatusMessagesProps {
  messages: string[];
}

const StatusMessages: React.FC<StatusMessagesProps> = ({ messages }) =>
  messages.length ? (
    <div id="messages" role="alert">
      {messages.map((m, i) => (
        <div key={i}>{maybeLink(m)}</div>
      ))}
    </div>
  ) : null;

const maybeLink = (m: string) => {
  const piDashboardBase = "https://dashboard.stripe.com/test/payments";
  return (
    <span
      dangerouslySetInnerHTML={{
        __html: m.replace(
          /(pi_(\S*)\b)/g,
          `<a href="${piDashboardBase}/$1" target="_blank">$1</a>`
        ),
      }}
    ></span>
  );
};

type MessageAction = { type: "ADD"; message: string } | { type: "CLEAR" };

const messageReducer = (state: string[], action: MessageAction): string[] => {
  switch (action.type) {
    case "ADD":
      // Add a new message to the array
      return [...state, action.message];
    case "CLEAR":
      // Clear all messages
      return [];
    default:
      return state; // In case of an unhandled action, return the current state
  }
};

// Hook that uses the reducer for message management
const useMessages = () => {
  return useReducer(messageReducer, []); // Initial state is an empty array of messages
};

export default StatusMessages;
export { useMessages };
